import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import Events from '../utils/events';
import Drag from '../drag';
import Tooltip from '../tooltip';
import ensureValuePrecision from './utils/ensureValuePrecision';
import getValue from './utils/getValue';
import preventDefault from './utils/preventDefault';
import { isObject } from '../utils/validate';

var Slider = /*#__PURE__*/function (_PureComponent) {
  _inherits(Slider, _PureComponent);

  var _super = _createSuper(Slider);

  function Slider() {
    var _this;

    _classCallCheck(this, Slider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.line = null;
    _this.container = null;
    _this.offsetStart = 0;
    _this.state = {
      value: getValue(_this.props, 0),
      prevPropsValue: getValue(_this.props, 0),
      tooltip: false
    };

    _this.init = function () {
      var value = _this.state.value;
      _this.offsetStart = _this.getOffsetByValue(value);
    };

    _this.getValueByOffset = function (offset) {
      var _this$props = _this.props,
          _this$props$min = _this$props.min,
          min = _this$props$min === void 0 ? 0 : _this$props$min,
          max = _this$props.max,
          vertical = _this$props.vertical;

      var percent = offset / _this.getMaxOffset();

      var value = vertical ? (1 - percent) * (max - min) + min : Math.round(min + (max - min) * percent);
      return ensureValuePrecision(value, _this.props);
    };

    _this.getOffsetPercent = function (value) {
      var _this$props2 = _this.props,
          min = _this$props2.min,
          max = _this$props2.max;
      var ratio = (value - min) / (max - min);
      return "".concat(ratio * 100, "%");
    };

    _this.getOffsetByValue = function (value) {
      var _this$props3 = _this.props,
          vertical = _this$props3.vertical,
          min = _this$props3.min,
          max = _this$props3.max;

      var maxOffset = _this.getMaxOffset();

      var range = max - min;
      return vertical ? maxOffset * ((max - value) / range) : maxOffset * ((value - min) / range);
    };

    _this.getMaxOffset = function () {
      if (_this.line) {
        if (_this.props.vertical) {
          return _this.line.offsetHeight;
        }

        return _this.line.offsetWidth;
      }

      return 0;
    };

    _this.handleDragStart = function () {
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      _this.setState({
        tooltip: true
      });
    };

    _this.handleDragMove = function (event, dragState) {
      var _this$props4 = _this.props,
          disabled = _this$props4.disabled,
          vertical = _this$props4.vertical;

      if (disabled) {
        return false;
      }

      Tooltip.updateAll();
      event.stopPropagation();

      if (!Events.supportsPassiveEvents) {
        event.preventDefault();
      }

      var _ref = dragState,
          offsetX = _ref.offsetX,
          offsetY = _ref.offsetY;
      var offset = vertical ? _this.offsetStart + (offsetY || 0) : (_this.offsetStart || 0) + (offsetX || 0);

      if (offset < 0) {
        offset = 0;

        var newValue = _this.getValueByOffset(offset);

        _this.setState({
          value: newValue
        });

        return false;
      }

      var maxOffset = _this.getMaxOffset();

      if (offset > maxOffset) {
        offset = maxOffset;

        var _newValue = _this.getValueByOffset(offset);

        _this.setState({
          value: _newValue
        });

        return false;
      }

      var value = _this.getValueByOffset(offset);

      _this.setState({
        value: value
      });

      return true;
    };

    _this.handleDragEnd = function (_event, dragState) {
      var _this$props5 = _this.props,
          vertical = _this$props5.vertical,
          onChange = _this$props5.onChange;
      var offsetX = dragState.offsetX,
          offsetY = dragState.offsetY;

      _this.setState({
        tooltip: false
      });

      if (vertical) {
        if (Number.isNaN(offsetY)) {
          return;
        }
      } else if (Number.isNaN(offsetX)) {
        return;
      }

      _this.offsetStart += vertical ? offsetY : offsetX;

      if (typeof onChange === 'function') {
        onChange(_this.state.value);
      }
    };

    _this.handleRef = function (ref) {
      var nextContainer = ref;
      var prevContainer = _this.container;

      if (prevContainer !== nextContainer) {
        if (prevContainer) {
          prevContainer.removeEventListener('touchstart', preventDefault);
        }

        if (nextContainer) {
          nextContainer.addEventListener('touchstart', preventDefault, {
            passive: false
          });
        }
      }

      _this.container = nextContainer;
    };

    _this.renderMarkInfo = function () {
      var _this$props6 = _this.props,
          prefixCls = _this$props6.prefixCls,
          showMark = _this$props6.showMark,
          _this$props6$marks = _this$props6.marks,
          marks = _this$props6$marks === void 0 ? {} : _this$props6$marks,
          vertical = _this$props6.vertical;
      var value = _this.state.value;
      var isEmptyMarks = !isObject(marks) || JSON.stringify(marks) === '{}';

      if (showMark && isEmptyMarks) {
        // TODO: i18n
        console.error('请输入有效的 marks');
        return null;
      } // 判断是否为空对象


      if (isEmptyMarks) {
        return null;
      }

      var markKeys = Object.keys(marks || {});
      var markElement = markKeys.map(function (item) {
        var markStyle = _defineProperty({}, vertical ? 'bottom' : 'left', "".concat(item, "%"));

        return /*#__PURE__*/React.createElement("span", {
          key: item,
          className: "".concat(prefixCls, "__mark"),
          style: markStyle
        }, marks[+item]);
      });
      var marksElement = showMark && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__marks")
      }, markElement);
      var lineDot = markKeys.map(function (item) {
        var dotStyle = classnames("".concat(prefixCls, "__line__dot"), _defineProperty({}, "".concat(prefixCls, "__line__dot--active"), value >= +item));

        var markStyle = _defineProperty({}, vertical ? 'bottom' : 'left', "".concat(item, "%"));

        return /*#__PURE__*/React.createElement("span", {
          key: item,
          className: dotStyle,
          style: markStyle
        });
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, lineDot, marksElement);
    };

    return _this;
  }

  _createClass(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();
      Events.on(window, 'resize', this.init);
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames2,
          _this2 = this;

      var _this$props7 = this.props,
          prefixCls = _this$props7.prefixCls,
          className = _this$props7.className,
          disabled = _this$props7.disabled,
          min = _this$props7.min,
          max = _this$props7.max,
          vertical = _this$props7.vertical,
          showMark = _this$props7.showMark;
      var _this$state = this.state,
          value = _this$state.value,
          tooltip = _this$state.tooltip;
      var offset = this.getOffsetPercent(value);
      var cls = classnames(prefixCls, className, (_classnames2 = {}, _defineProperty(_classnames2, "".concat(prefixCls, "--disabled"), disabled), _defineProperty(_classnames2, "".concat(prefixCls, "--vertical"), vertical), _defineProperty(_classnames2, "".concat(prefixCls, "--marked"), showMark), _classnames2));

      var handleStyle = _defineProperty({}, vertical ? 'bottom' : 'left', offset || 0);

      var lineBg = _defineProperty({}, vertical ? 'height' : 'width', offset || 0);

      return /*#__PURE__*/React.createElement("div", {
        className: cls,
        ref: this.handleRef
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__content")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__line"),
        ref: function ref(ele) {
          _this2.line = ele;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__line__bg"),
        style: lineBg
      }), this.renderMarkInfo()), /*#__PURE__*/React.createElement(Drag, {
        onDragStart: this.handleDragStart,
        onDragMove: this.handleDragMove,
        onDragEnd: this.handleDragEnd
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__handle"),
        role: "slider",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        "aria-orientation": vertical ? 'vertical' : 'horizontal',
        style: handleStyle
      }, /*#__PURE__*/React.createElement(Tooltip, {
        trigger: "manual",
        arrowPointAtCenter: true,
        visible: tooltip,
        content: value
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__handle__shadow")
      }))))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var value = nextProps.value;

      if (typeof value !== 'undefined' && value !== prevState.prevPropsValue) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          value: value,
          prevPropsValue: value
        });
      }

      return null;
    }
    /**
     * 初始化
     */

  }]);

  return Slider;
}(PureComponent);

Slider.defaultProps = {
  prefixCls: 'za-slider',
  disabled: false,
  showMark: false,
  vertical: false,
  step: 1,
  min: 0,
  max: 100,
  marks: {}
};
export { Slider as default };